import { finalize, share, catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { EndpointsName, get, getCurrentUser } from "../../Auth";
import { shareSubjectWithDelay } from '../apiHelper';
import { FactoryConfig, IGlobalConfig, IGlobalConfigCurrentState, ProcessType } from '../../types';
import { withLogger } from '../LogerServices';

const INITIAL_GLOBAL_STATE: IGlobalConfigCurrentState = {
    name: '',
    data: null
};

const GLOBAL_CONFIG: IGlobalConfig = {
    current: { ...INITIAL_GLOBAL_STATE }
};

const ConfigFactory = {
    get: null as Observable<FactoryConfig>,
};

const setCurrentFactoryData = (data: FactoryConfig, factory: string) => {
    const currentFactory = {
        name: factory,
        data
    };
    GLOBAL_CONFIG.current = currentFactory;
}

const getFactoryConfigsObservable = (factory: string) => {
    ConfigFactory.get = shareSubjectWithDelay(withLogger(get<FactoryConfig>(EndpointsName.GLOBAL, '/configs'), ProcessType.FACTORY).pipe(
        finalize(() => ConfigFactory.get = null),
        tap(data => setCurrentFactoryData(data, factory)),
        share(),
        catchError((err) => {
            GLOBAL_CONFIG.current = { ...INITIAL_GLOBAL_STATE };
            throw err
        })
    ));
    return ConfigFactory.get
};

export const getFactoryConfigs = () => {
    const { factory } = getCurrentUser()
    if (factory === GLOBAL_CONFIG.current.name) {
        return of(GLOBAL_CONFIG.current.data)
    }
    return ConfigFactory.get ?? getFactoryConfigsObservable(factory)
};